module.exports = __webpack_public_path__ + "static/media/homepage-banner-monitoring-icon.a330fa8b.svg";